import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './contact.css';

export default function Contact() {
  const [data, setData] = useState({
    name: '',
    number: '',
    mail: '',
    message: '',
  });

  const { name, number, mail, message } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    emailjs
      .sendForm('service_wp5fg25', 'template_rlt0bfg',e.target, {
        publicKey: '9oLRZGqYbI-iCb1mM',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
      e.target.reset()
  };

  return (
    <div className='contact'>
      <h1>Contact Form</h1>
      <div className='c1'>
        <div className='c1leftside'>
          <form onSubmit={handleSubmit}>
            <label>Name*</label>
            <br />
            <input
              value={name}
              name='name'
              onChange={handleChange}
              className='boxes'
              type='text'
              placeholder='Name'
              required
            />
            <br />
            <label>Phone Number*</label>
            <br />
            <input
              value={number}
              name='number'
              onChange={handleChange}
              className='boxes'
              type='number'
              placeholder='Phone number'
              required
            />
            <br />
            <label>Gmail Id*</label>
            <br />
            <input
              value={mail}
              name='mail'
              onChange={handleChange}
              className='boxes'
              type='text'
              placeholder='Gmailid'
              required
            />
            <br />
            <label>Message*</label>
            <br />
            <textarea
              value={message}
              name='message'
              onChange={handleChange}
              className='textbox'
              placeholder='Message'
              required
            />
            <br />
            <button className='bt1' type='submit'>Submit</button>
          </form>
        </div>
        <div className='c1right'>
          <img className='image' src='./img8.jpg' alt='' />
        </div>
      </div>
    </div>
  );
}
